export default __webpack_public_path__ + "static/media/MissionControl2.763f1acb.png";